import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import API_BASE from '../api';

const POSITIONS = ['שוער','בלם','מגן ימין','מגן שמאל','קשר הגנתי','קשר','קשר התקפי','קיצוני ימין','קיצוני שמאל','חלוץ'];

export default function ReorderForm() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const urlProduct = searchParams.get('product') || '';
  const urlPrice   = searchParams.get('price')   || '';
  const [customer, setCustomer] = useState(null);
  const [formSettings, setFormSettings] = useState({ price: 0, product_name: 'קליפ ביצועים' });
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const [jerseyNumber, setJerseyNumber] = useState('');
  const [positions, setPositions] = useState('');
  const [opponentTeam, setOpponentTeam] = useState('');
  const [gameType, setGameType] = useState('full');
  const [notes, setNotes] = useState('');
  const [customProductName, setCustomProductName] = useState('');
  const [customPrice, setCustomPrice] = useState('');

  useEffect(() => {
    Promise.all([
      fetch(API_BASE + '/customers/' + id + '/public').then(r => r.json()),
      fetch(API_BASE + '/form-settings').then(r => r.json()),
    ]).then(([cust, fs]) => {
      if (cust.error) { setError('קישור לא תקין'); setLoading(false); return; }
      setCustomer(cust);
      setJerseyNumber(cust.jersey_number || '');
      setPositions(cust.positions || '');
      setFormSettings(fs);
      if (urlProduct) setCustomProductName(urlProduct);
      if (urlPrice)   setCustomPrice(urlPrice);
      setLoading(false);
    }).catch(() => { setError('שגיאת טעינה'); setLoading(false); });
  }, [id]);

  const togglePosition = p => {
    const cur = positions ? positions.split(',').map(s=>s.trim()).filter(Boolean) : [];
    const next = cur.includes(p) ? cur.filter(x=>x!==p) : [...cur, p];
    setPositions(next.join(', '));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const gameNote = gameType === 'full' ? 'סוג משחק: משחק מלא' : gameType === 'multiple' ? 'סוג משחק: מספר משחקים מלאים' : 'סוג משחק: קטעים ממשחקים שונים';
      const allNotes = [notes, gameNote].filter(Boolean).join(' | ');
      const res = await fetch(API_BASE + '/customers/' + id + '/quick-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          jersey_number: jerseyNumber,
          positions,
          opponent_team: opponentTeam,
          product_name: customProductName || formSettings.product_name,
          unit_price: customPrice !== '' ? parseFloat(customPrice) : formSettings.price,
          notes: allNotes,
        }),
      });
      if (!res.ok) throw new Error();
      setDone(true);
    } catch {
      setError('שגיאה בשליחה, נסה שוב');
    }
    setSubmitting(false);
  };

  const inputStyle = { width:'100%', background:'#0d1b3e', border:'1px solid #1e3060', borderRadius:10, padding:'12px 14px', color:'#fff', fontSize:'1rem', direction:'rtl', boxSizing:'border-box' };
  const labelStyle = { color:'#8a9aba', fontSize:'0.85rem', fontWeight:600, display:'block', marginBottom:6, textAlign:'right' };

  if (loading) return (
    <div style={{ minHeight:'100vh', background:'#060d1e', display:'flex', alignItems:'center', justifyContent:'center', color:'#d4af37', fontFamily:'Heebo, sans-serif', fontSize:'1.2rem' }}>
      ⏳ טוען...
    </div>
  );

  if (error && !customer) return (
    <div style={{ minHeight:'100vh', background:'#060d1e', display:'flex', alignItems:'center', justifyContent:'center', color:'#ff6b6b', fontFamily:'Heebo, sans-serif', fontSize:'1.1rem' }}>
      {error}
    </div>
  );

  if (done) return (
    <div style={{ minHeight:'100vh', background:'#060d1e', display:'flex', alignItems:'center', justifyContent:'center', direction:'rtl', padding:20 }}>
      <div style={{ background:'#0d1b3e', border:'2px solid rgba(212,175,55,0.4)', borderRadius:20, padding:'40px 32px', maxWidth:460, width:'100%', textAlign:'center', fontFamily:'Heebo, sans-serif' }}>
        <div style={{ fontSize:'3rem', marginBottom:16 }}>🎬</div>
        <h2 style={{ color:'#d4af37', fontWeight:900, fontSize:'1.5rem', marginBottom:12 }}>תודה! ההזמנה התקבלה</h2>
        <p style={{ color:'#c0cce6', lineHeight:1.8 }}>צוות יוסטאר קיבל את הפרטים ויחזור אליכם בהקדם.</p>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight:'100vh', background:'#060d1e', direction:'rtl', padding:'36px 20px', fontFamily:'Heebo, sans-serif' }}>
      <div style={{ maxWidth:500, margin:'0 auto' }}>
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <div style={{ fontSize:'2rem', marginBottom:8 }}>🎬</div>
          <h1 style={{ color:'#d4af37', fontWeight:900, fontSize:'clamp(1.2rem,4vw,1.6rem)', margin:0 }}>הזמנת קליפ — {customer?.child_name} {customer?.child_last_name}</h1>
          <p style={{ color:'#8a9aba', marginTop:8, fontSize:'0.9rem' }}>מלאו את הפרטים לסבב הבא</p>
        </div>

        <form onSubmit={handleSubmit} style={{ background:'#0d1b3e', border:'1px solid #1e3060', borderRadius:16, padding:'24px 22px' }}>

          {/* מוצר + מחיר */}
          <div style={{ background:'rgba(212,175,55,0.07)', border:'1px solid rgba(212,175,55,0.25)', borderRadius:12, padding:'14px 16px', marginBottom:20 }}>
            <div style={{ color:'#d4af37', fontWeight:800, fontSize:'0.85rem', marginBottom:10 }}>📦 פרטי ההזמנה</div>
            {/* אם הגיע מקישור עם מוצר+מחיר — מוצג קבוע */}
            {(urlProduct && urlPrice) ? (
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                <span style={{ color:'#c0cce6', fontWeight:800, fontSize:'1rem' }}>{customProductName || urlProduct}</span>
                <span style={{ color:'#d4af37', fontWeight:900, fontSize:'1.1rem' }}>₪{customPrice || urlPrice}</span>
              </div>
            ) : (
              <>
                <div style={{ marginBottom:10 }}>
                  <label style={labelStyle}>סוג מוצר</label>
                  <input style={inputStyle} value={customProductName}
                    onChange={e => setCustomProductName(e.target.value)}
                    placeholder={formSettings.product_name || 'קליפ ביצועים'} />
                </div>
                <div>
                  <label style={labelStyle}>מחיר ₪</label>
                  <input style={inputStyle} type="number" value={customPrice}
                    onChange={e => setCustomPrice(e.target.value)}
                    placeholder={formSettings.price > 0 ? String(formSettings.price) : 'הזן מחיר'} />
                </div>
              </>
            )}
          </div>

          {/* שם הילד — read-only */}
          <div style={{ marginBottom:16 }}>
            <label style={labelStyle}>שחקן</label>
            <div style={{ ...inputStyle, color:'#8a9aba', cursor:'default' }}>{customer?.child_name} {customer?.child_last_name}</div>
          </div>

          {/* מספר חולצה */}
          <div style={{ marginBottom:16 }}>
            <label style={labelStyle}>מספר חולצה</label>
            <input style={inputStyle} type="number" value={jerseyNumber} onChange={e=>setJerseyNumber(e.target.value)} placeholder="7" />
          </div>

          {/* עמדות */}
          <div style={{ marginBottom:16 }}>
            <label style={labelStyle}>עמדה/ות בשטח</label>
            <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
              {POSITIONS.map(p => (
                <button key={p} type="button" onClick={() => togglePosition(p)}
                  style={{ padding:'6px 14px', borderRadius:20, border:'1px solid', fontSize:'0.8rem', cursor:'pointer', fontFamily:'Heebo, sans-serif',
                    background: positions?.includes(p) ? 'rgba(212,175,55,0.2)' : 'transparent',
                    borderColor: positions?.includes(p) ? '#d4af37' : '#2a3a6a',
                    color: positions?.includes(p) ? '#d4af37' : '#8a9aba' }}>
                  {p}
                </button>
              ))}
            </div>
          </div>

          {/* יריבה */}
          <div style={{ marginBottom:16 }}>
            <label style={labelStyle}>נגד איזו יריבה? (אופציונלי)</label>
            <input style={inputStyle} value={opponentTeam} onChange={e=>setOpponentTeam(e.target.value)} placeholder="שם הקבוצה היריבה" />
          </div>

          {/* סוג משחק */}
          <div style={{ marginBottom:16 }}>
            <label style={labelStyle}>סוג משחק</label>
            <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
              {[
                { value:'full', label:'משחק מלא' },
                { value:'multiple', label:'מספר משחקים מלאים' },
                { value:'clips', label:'קטעים ממשחקים שונים' },
              ].map(({ value, label }) => (
                <label key={value} style={{ display:'flex', alignItems:'center', gap:10, cursor:'pointer', color:'#c0cce6', fontSize:'0.9rem' }}>
                  <input type="radio" checked={gameType === value} onChange={()=>setGameType(value)} style={{ accentColor:'#d4af37', width:17, height:17 }} />
                  {label}
                </label>
              ))}
            </div>
          </div>

          {/* הערות */}
          <div style={{ marginBottom:20 }}>
            <label style={labelStyle}>הערות (אופציונלי)</label>
            <textarea style={{ ...inputStyle, minHeight:70, resize:'vertical' }} value={notes} onChange={e=>setNotes(e.target.value)} placeholder="פרטים נוספים..." />
          </div>

          {error && <div style={{ background:'rgba(255,80,80,0.1)', border:'1px solid rgba(255,80,80,0.3)', borderRadius:8, padding:'10px 14px', color:'#ff8888', marginBottom:14, textAlign:'center' }}>{error}</div>}

          <button type="submit" disabled={submitting} style={{
            width:'100%', background:'linear-gradient(135deg,#d4af37,#f0cc60)',
            color:'#0a1120', fontWeight:900, fontSize:'1rem', padding:'15px', borderRadius:12,
            border:'none', cursor:'pointer', fontFamily:'Heebo, sans-serif'
          }}>
            {submitting ? '...שולח' : '🎬 שלחו פרטים וצוות יוסטאר יתחיל לעבוד'}
          </button>
        </form>
      </div>
    </div>
  );
}
